import React from 'react';
import './styling.css';

function NavigationComponent({ canGoBack, canGoNext, onBack, onNext }) {
  return (
    <div className="navigation-container">
      <button
        className={`nav-back-btn${canGoBack ? '' : ' disabled'}`}
        onClick={onBack}
        disabled={!canGoBack}
      >
        Previous
      </button>
      <button
        className={`nav-next-btn${canGoNext ? '' : ' disabled'}`}
        onClick={onNext}
        disabled={!canGoNext}
      >
        Next
      </button>
    </div>
  );
}

export default NavigationComponent;
